export enum LeadsActionType {
	REQUEST = 'REQUEST',
	SUCCESS = 'SUCCESS',
	FAILED = 'FAILED',

	FETCH_LEADS = 'FETCH_LEADS',
	STORE_LEADS = 'STORE_LEADS',
	ERROR_LEADS = 'ERROR_LEADS',

	FETCH_LEAD_DETAILS = 'FETCH_LEAD_DETAILS',
	STORE_LEAD_DETAILS = 'STORE_LEAD_DETAILS',
	ERROR_STORE_LEAD_DETAILS = 'ERROR_LEAD_DETAILS',

	CREATE_LEAD = 'CREATE_LEAD',
	ERROR_LEAD = 'ERROR_LEAD',

	UPDATE_LEAD_BASIC_DETAILS = 'UPDATE_LEAD_BASIC_DETAILS',

	FETCH_LEAD_PROJECTS = 'FETCH_LEAD_PROJECTS',
	ERROR_FETCH_LEAD_PROJECTS = 'ERROR_FETCH_LEAD_PROJECTS',
	STORE_LEAD_PROJECTS = 'STORE_LEAD_PROJECTS',

	FETCH_LEAD_AUTOCOMPLETE = 'FETCH_LEAD_AUTOCOMPLETE',
	ERROR_FETCH_LEAD_AUTOCOMPLETE = 'ERROR_FETCH_LEAD_AUTOCOMPLETE',
	STORE_LEAD_AUTOCOMPLETE = 'STORE_LEAD_AUTOCOMPLETE',

	FETCH_LEAD_USER_AUTOCOMPLETE = 'FETCH_LEAD_USER_AUTOCOMPLETE',
	ERROR_FETCH_LEAD_USER_AUTOCOMPLETE = 'ERROR_FETCH_LEAD_USER_AUTOCOMPLETE',
	STORE_LEAD_USER_AUTOCOMPLETE = 'STORE_LEAD_USER_AUTOCOMPLETE',

	FETCH_LEAD_QUOTATIONS = 'FETCH_LEAD_QUOTATIONS',
	STORE_LEAD_QUOTATIONS = 'STORE_LEAD_QUOTATIONS',
	ERROR_LEAD_QUOTATIONS = 'ERROR_LEAD_QUOTATIONS',
	UPLOAD_QUOTATION_PDF = 'UPLOAD_QUOTATION_PDF',
	DELETE_QUOTATION_VERSION = 'DELETE_QUOTATION_VERSION',

	ERROR_LEAD_QUOTATION = 'ERROR_LEAD_QUOTATION',
	UPDATE_LEAD_QUOTATION = 'UPDATE_LEAD_QUOTATION',

	FETCH_QUOTATION_LIST = 'FETCH_QUOTATION_LIST',
	STORE_QUOTATION_LIST = 'STORE_QUOTATION_LIST',
	ERROR_QUOTATION_LIST = 'ERROR_QUOTATION_LIST',

	FETCH_LEAD_CUSTOM_QUOTATIONS = 'FETCH_LEAD_CUSTOM_QUOTATIONS',
	STORE_LEAD_CUSTOM_QUOTATIONS = 'STORE_LEAD_CUSTOM_QUOTATIONS',
	ERROR_LEAD_CUSTOM_QUOTATIONS = 'ERROR_LEAD_CUSTOM_QUOTATIONS',

	UPDATE_QUOTATION_ITEM = 'UPDATE_QUOTATION_ITEM',

	ADD_AREA_TO_QUOTATION = 'ADD_AREA_TO_QUOTATION',

	CHANGE_AREA_NICKNAME = 'CHANGE_AREA_NICKNAME',

	UPLOAD_QUOTATION_IMAGE = 'UPLOAD_QUOTATION_IMAGE',

	CHANGE_QUOTATION_IMAGE = 'CHANGE_QUOTATION_IMAGE',

	COPY_QUOTATION_ITEM = 'COPY_QUOTATION_ITEM',

	UPDATE_FC_BUILDER = 'UPDATE_FC_BUILDER',

	FETCH_BUILDER_FC_DATA = 'FETCH_BUILDER_FC_DATA',
	STORE_BUILDER_FC_DATA = 'STORE_BUILDER_FC_DATA',

	FETCH_LEAD_CREDITS = 'FETCH_LEAD_CREDITS',
	STORE_LEAD_CREDITS = 'STORE_LEAD_CREDITS',
	ERROR_LEAD_CREDITS = 'ERROR_LEAD_CREDITS',

	ADD_LEAD_CREDITS = 'ADD_LEAD_CREDITS',

	IMPORT_QUOTATION = 'IMPORT_QUOTATION',

	FETCH_LEAD_SOURCE_HISTORY = 'FETCH_LEAD_SOURCE_HISTORY',
	STORE_LEAD_SOURCE_HISTORY = 'STORE_LEAD_SOURCE_HISTORY',
	ERROR_FETCH_LEAD_SOURCE_HISTORY = 'ERROR_FETCH_LEAD_SOURCE_HISTORY',

	FETCH_LEAD_REMARKS = 'FETCH_LEAD_REMARKS',
	STORE_LEAD_REMARKS = 'STORE_LEAD_REMARKS',
	ERROR_FETCH_LEAD_REMARKS = 'ERROR_FETCH_LEAD_REMARKS',
	PUT_LEAD_REMARK = 'PUT_LEAD_REMARK',

	FETCH_QUOTATION_LIST_BACKGROUND = 'FETCH_QUOTATION_LIST_BACKGROUND',
	STORE_QUOTATION_LIST_BACKGROUND = 'STORE_QUOTATION_LIST_BACKGROUND',
	ERROR_QUOTATION_LIST_BACKGROUND = 'ERROR_QUOTATION_LIST_BACKGROUND',

	REFRESH_QUOTATION_COSTING = 'REFRESH_QUOTATION_COSTING',
	STORE_REFRESH_QUOTATION_COSTING_STATUS = 'STORE_REFRESH_QUOTATION_COSTING_STATUS',
	REFRESH_QUOTATION_COSTING_FAILED = 'REFRESH_QUOTATION_COSTING_FAILED',

	FETCH_COSTING_SYNC_STATUS = 'FETCH_COSTING_SYNC_STATUS',
	STORE_COSTING_SYNC_STATUS = 'STORE_COSTING_SYNC_STATUS',
	ERROR_COSTING_SYNC_STATUS = 'ERROR_COSTING_SYNC_STATUS'
}
